import { createNode } from '@glueapp/graph-types';
import { GoogleDriveIntegration } from './GoogleDriveIntegration';

interface GoogleDriveFiles {
    files: { id: string; name: string }[];
}

export const GetAllFiles = createNode({
    id: 'Get Google Drive Files',
    name: 'Get Google Drive Files',
    description: 'Get all your Google Drive Files',
    aiDescription:
        'Requires the Google Drive integration to be connected. Takes an optional "MIME Type" (string) input port to filter files by type (e.g., "application/pdf"). Outputs a "Files" port containing an array of objects with "id" and "name" properties for each file found.',
    category: 'Google Drive',
    color: '#e44232',
    integration: GoogleDriveIntegration,
    inPorts: {
        'MIME Type': {
            kind: 'string',
        },
    },
    outPorts: {
        Files: {
            kind: 'array',
            subType: {
                kind: 'object',
                restriction: 'open',
                properties: {
                    id: { kind: 'string' },
                    name: { kind: 'string' },
                },
            },
        },
    },
    isAsync: true,
    execute: async function (input) {
        try {
            const mimeType = input.inPorts['MIME Type'];
            const response = await input.integration.callIntegration<GoogleDriveFiles>({
                url: 'https://www.googleapis.com/drive/v3/files',
                params: {
                    q: mimeType ? `mimeType = '${mimeType}'` : undefined,
                },
            });
            const filesResponse: GoogleDriveFiles = response.data;
            return { output: { Files: filesResponse.files.map(file => ({ id: file.id, name: file.name })) } };
        } catch {
            return { output: { Files: [] } };
        }
    },
});
